const customTheme = {
  tokens: {
    colorBackgroundLayoutMain: {
      dark: "#18181B",
      light: "#FAFAF9",
    },
    colorBackgroundContainerContent: {
      dark: "#1D1D20",
      light: "#F5F5F4",
    },
    colorBackgroundPopover: {
      dark: "#1D1D20",
      light: "#F5F5F4",
    },
    colorBackgroundContainerHeader: {
      dark: "#1D1D20",
      light: "#F5F5F4",
    },
    colorBackgroundNotificationSeverityHigh: {
      dark: "#ce3311",
    },
    colorBackgroundNotificationSeverityMedium: {
      dark: "#cc5f21",
    },
    colorBackgroundNotificationSeverityCritical: {
      dark: "#870303",
    },
    colorTextNotificationSeverityCritical: {
      dark: "#f9f9fa",
    },
    colorTextNotificationSeverityHigh: {
      dark: "#f9f9fa",
    },
    colorBackgroundControlDefault: {
      dark: "#171D25",
    },
    colorBackgroundInputDefault: {
      dark: "#222225",
    },
    colorBackgroundHomeHeader: {
      dark: "#171D25",
    },
    colorTextLinkDefault: {
      light: "#101828",
      dark: "#FFFFFF",
    },
    colorTextLinkHover: {
      light: "#101828",
      dark: "#FFFFFF",
    },
    colorTextDropdownItemHighlighted: {
      light: "#101828",
      dark: "#FFFFFF",
    },
    colorBackgroundButtonLinkHover: {
      light: "#EEEEEE",
      dark: "#2a2a2c",
    },
    colorTextButtonNormalDefault: {
      light: "#18181B",
      dark: "#FAFAF9",
    },
    colorTextButtonNormalHover: {
      light: "#18181B",
      dark: "#FAFAF9",
    },
    colorTextInteractiveHover: {
      light: "#14110f",
      dark: "#F4F4F5",
    },
    colorTextInteractiveActive: {
      light: "#14110f",
      dark: "#F4F4F5",
    },
    colorTextAccent: {
      light: "#14110f",
      dark: "#F4F4F5",
    },
    colorTextInteractiveDefault: {
      light: "#79716b",
      dark: "#949495",
    },
    colorTextButtonNormalActive: {
      light: "#18181B",
      dark: "#FAFAF9",
    },
    colorBackgroundButtonLinkActive: {
      light: "#EEEEEE",
      dark: "#212124",
    },
    borderRadiusButton: "10px",
    borderRadiusInput: "8px",
    borderRadiusContainer: "12px",
    colorForegroundControlDefault: {
      dark: "#18181B",
      light: "#FAFAF9",
    },
    colorForegroundControlDisabled: {
      dark: "#18181B",
      light: "#FAFAF9",
    },
    colorBackgroundDropdownItemHover: {
      light: "#F5F5F4",
      dark: "#1D1D20",
    },
    colorBackgroundDropdownItemDefault: {
      dark: "#18181B",
      light: "#FAFAF9",
    },
    colorTextDropdownItemDefault: {
      light: "#101828",
      dark: "#FFFFFF",
    },
    colorBackgroundButtonNormalHover: {
      light: "#ececec",
      dark: "#424242",
    },
    colorBackgroundButtonNormalActive: {
      light: "#ececec",
      dark: "#424242",
    },
    colorBackgroundButtonNormalDefault: {
      light: "transparent",
      dark: "transparent",
    },
    colorTextButtonPrimaryDefault: {
      light: "#FAFAF9",
      dark: "#14110f",
    },
    colorTextButtonPrimaryHover: {
      light: "#FAFAF9",
      dark: "#14110f",
    },
    colorTextButtonPrimaryActive: {
      light: "#FAFAF9",
      dark: "#14110f",
    },
    colorBackgroundButtonPrimaryActive: {
      light: "#8F8F8F",
      dark: "#8e8e8e",
    },
    colorBackgroundButtonPrimaryDefault: {
      light: "#858585",
      dark: "#949494",
    },
    colorBackgroundButtonPrimaryHover: {
      light: "#8F8F8F",
      dark: "#8e8e8e",
    },
    colorBackgroundInputDisabled: {
      light: "#FAFAF9",
      dark: "#18181B",
    },
    colorBackgroundButtonNormalDisabled: {
      dark: "#1D1D20",
      light: "#F5F5F4",
    },
    colorBorderButtonNormalDisabled: {
      dark: "#1D1D20",
      light: "#F5F5F4",
    },
    colorBackgroundButtonPrimaryDisabled: {
      light: "#DDDDDD",
      dark: "#3a3a3c",
    },
    colorBorderButtonNormalHover: {
      light: "#79716b",
      dark: "#949495",
    },
    colorBorderButtonNormalActive: {
      light: "#79716b",
      dark: "#949495",
    },
    colorBorderButtonNormalDefault: {
      light: "#79716b",
      dark: "#949495",
    },
    colorBackgroundSegmentActive: {
      light: "#858585",
      dark: "#949494",
    },
    colorBackgroundChatBubbleIncoming: {
      light: "#E9E9E8",
      dark: "#2A2A2C",
    },

    // colorBorderDropdownItemFocused: {
    //   light: "transparent",
    //   dark: "#000000",
    // },
    // colorBorderItemSelected: {
    //   light: "transparent",
    //   dark: "#000000",
    // },
  },
  contexts: {
    "top-navigation": {
      tokens: {
        colorBackgroundContainerContent: {
          light: "#F5F5F4",
          dark: "#1D1D20",
        },
        colorTextDropdownItemHighlighted: {
          light: "#101828",
          dark: "#FFFFFF",
        },
        colorBorderDividerDefault: {
          light: "#F5F5F4",
          dark: "#1D1D20",
        },
        colorTextButtonNormalDefault: {
          light: "#79716b",
          dark: "#949495",
        },
        colorBackgroundButtonLinkHover: {
          light: "#EEEEEE",
          dark: "#2a2a2c",
        },
        colorTextButtonNormalHover: {
          light: "#14110f",
          dark: "#F4F4F5",
        },
        colorTextInteractiveHover: {
          light: "#14110f",
          dark: "#F4F4F5",
        },
        colorTextInteractiveActive: {
          light: "#14110f",
          dark: "#F4F4F5",
        },
        colorTextAccent: {
          light: "#14110f",
          dark: "#F4F4F5",
        },
        colorTextInteractiveDefault: {
          light: "#79716b",
          dark: "#949495",
        },
        colorTextButtonNormalActive: {
          light: "#14110f",
          dark: "#F4F4F5",
        },
        colorBackgroundButtonLinkActive: {
          light: "#EEEEEE",
          dark: "#212124",
        },
        borderRadiusButton: "8px",
        colorBackgroundDropdownItemHover: {
          light: "#F5F5F4",
          dark: "#1D1D20",
        },
        colorBackgroundDropdownItemDefault: {
          dark: "#18181B",
          light: "#FAFAF9",
        },
        colorTextDropdownItemDefault: {
          light: "#101828",
          dark: "#FFFFFF",
        },
        colorBorderDropdownItemFocused: {
          light: "#FFFFFF",
          dark: "#000000",
        },
      },
    },
  },
};

export default customTheme;
